import styled from "styled-components";

export const MonthlyEstimate = styled.div<{ variant?: "default" | "dark" }>`
  padding: 16px 24px;
  border-radius: 8px;
  ${({ variant }) =>
    variant === "dark"
      ? `background-color: var(--section-color-neutral-300-background-color,var(--color-neutral-300))`
      : `background-color: var(--section-color-primary-100-background-color,var(--color-primary-100))`};
`;

export const DialogWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
